import { useEffect, RefObject } from 'react';

/**
 * Перезапускает видео с начала каждый раз при показе.
 */
export const useVideoControl = (
    videoRef: RefObject<HTMLVideoElement | null>,
    isVisible: boolean,
    videoSrc?: string,
) => {
    useEffect(() => {
        if (!videoRef.current || !videoSrc) {
            return;
        }

        if (isVisible) {
            videoRef.current.currentTime = 0;
            videoRef.current.play().catch(() => {
                // Игнорируем ошибки автовоспроизведения
            });
        } else {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    }, [videoRef, isVisible, videoSrc]);
};
